import enUS from './en-us.json'; // English - United States

export default {
  'en-us': enUS,
};
